import React, {Component} from 'react';
import {NextTrainBostonHeader, NextTrainBostonNav} from '../links';

const styles = {
    container: {
        fontSize: '1.2rem',
        lineHeight: 1.5,
        margin: '0 auto',
        maxWidth: 800,
        padding: '0 1rem',
    },
    header: {
        textAlign: 'center',
    },
    summary: {
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
};

let _this;

class NextTrainBostonPrivacyPolicy extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;
    }

    render() {
        return (
            <div className="container">
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonPolicy"/>
                <br/>
                <NextTrainBostonHeader/>
                <br/>
                <br/>
                <br/>
                <div style={styles.container}>
                    <h1 style={styles.header}>Privacy Policy</h1>
                    <div>
                        <p>
                            This Privacy Policy describes how AnswerSolutions LLC ("we," "us," or "our") handles
                            information when you use the Next Train Boston mobile application for iPhone and Apple Watch,
                            its widget, and this website (collectively, the "Services"). By using the Services, you agree
                            to this Privacy Policy. If you do not agree, please do not use the Services.
                        </p>
                        <p style={styles.summary}>
                            Summary: Next Train Boston does not collect personal data. There is no account, no login, no
                            analytics and no advertising. Your line, your commute and your recent stations stay on your
                            device. The only information we receive is what you choose to send us when you contact
                            support.
                        </p>
                        <p>
                            Information Stored on Your Device: The app keeps the line you picked, the home and work
                            stations and the hour of your commute, and a short list of recently opened stations. This
                            information is stored only on your iPhone (shared with the app's own widget and Apple Watch
                            app) and is never sent to us or to anyone else. Deleting the app deletes it.
                        </p>
                        <p>
                            Schedule Updates: To keep the timetable current, the app periodically downloads the latest
                            schedule file from our website, answersolutions.net. This download does not include any
                            information about you, your stations or your commute. Like any web server, ours records the
                            standard technical details of each request (such as the IP address and the time) in its logs,
                            which we use only to operate and secure the service and keep for a limited time.
                        </p>
                        <p>
                            Location: The app does not ask for or use your location.
                        </p>
                        <p>
                            Information You Send Us: When you contact us for support, we receive the information you
                            include, such as your email address and a description of your question. We use it only to
                            answer you and to improve the Services, and we do not share it unless required by law.
                        </p>
                        <p>
                            Third Parties: The Services are distributed through Apple's App Store, which may collect
                            information under Apple's own privacy policy. We do not use third-party analytics or
                            advertising services in the app.
                        </p>
                        <p>
                            Data Retention and Security: We keep support emails only as long as needed to answer them
                            and improve the Services. We take reasonable steps to protect the information we hold,
                            but no method of transmission over the internet or of electronic storage is completely
                            secure.
                        </p>
                        <p>
                            Children's Privacy: The Services are not directed to children under 13 and do not knowingly
                            collect information from them. If you believe a child has sent us personal information,
                            please contact us at support@answersolutions.net and we will delete it.
                        </p>
                        <p>
                            Changes to This Policy: We may update this Privacy Policy from time to time. We will post the
                            updated policy on this page before the changes take effect. Your continued use of the
                            Services after that constitutes acceptance of the revised policy.
                        </p>
                        <p>
                            Contact Us: If you have any questions about this Privacy Policy, please contact us at
                            support@answersolutions.net.
                        </p>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonPolicy" withProducts/>
                </div>
            </div>
        );
    }
}

export default NextTrainBostonPrivacyPolicy;
